export const initSmoothScroll = () => {
    const scrollToElement = targetElement => {
        const header = document.querySelector('.header');
        const headerOffset = header ? header.offsetHeight : 0;
        const elementPosition = targetElement.getBoundingClientRect().top;
        const startPosition = window.pageYOffset;
        const targetPosition = elementPosition + startPosition - headerOffset;

        const duration = 800; // czas trwania animacji w ms
        const start = performance.now();

        const animate = currentTime => {
            const timeElapsed = currentTime - start;
            const progress = Math.min(timeElapsed / duration, 1);

            // Funkcja easing dla płynniejszego ruchu
            const easeInOutQuad = t =>
                t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

            const distance = targetPosition - startPosition;
            const currentPosition =
                startPosition + distance * easeInOutQuad(progress);

            window.scrollTo(0, currentPosition);

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };

        requestAnimationFrame(animate);
    };

    document.addEventListener('click', e => {
        const link = e.target.closest('a');
        if (!link) return;

        const hash = link.hash;
        if (
            !hash ||
            link.origin + link.pathname !==
                window.location.origin + window.location.pathname
        )
            return;

        const targetElement = document.querySelector(hash);
        if (!targetElement) return;

        e.preventDefault();
        scrollToElement(targetElement);
    });

    window.addEventListener('load', () => {
        if (window.location.hash) {
            const targetElement = document.querySelector(window.location.hash);
            if (!targetElement) return;

            setTimeout(() => {
                scrollToElement(targetElement);
            }, 100);
        }
    });
};
